import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes';
import api from '../requests';

Vue.use(VueRouter);

const router = new VueRouter({
    routes,
    mode: 'history',
    linkActiveClass: 'active',
    linkExactActiveClass: 'active',
});

router.setUserRoles = (userRoles, router) => {
    router.$userRoles = userRoles;
  }
  
  const checkManutencaoByRoles = async (userRoles, next = null) => {
    let { data } = await api.get('manutencao');
    if (data.dados.flag_manutencao === "1" 
    && (!userRoles.includes('SUPERADMINISTRADOR') 
    && (!userRoles.includes('ADMINISTRADOR')
    && (!userRoles.includes('CONSULTA')
    && (!userRoles.includes('ADMINISTRADOR_RF')))))) 
    {
      window.location.href =
        "https://prefeitura.pbh.gov.br/smasac/auxiliobelohorizonte";
    } else {
      next();
    }
  }
  
  router.beforeResolve(async (to, from, next) => {
    let roles = await (router.$userRoles ? router.$userRoles : []);
    checkManutencaoByRoles(roles, next)
  });

export default router;